import {useErrorsServiceToken, useResourcesToken} from '@/di/di.root-container.hooks';

import {FC} from 'react';

import {HttpError} from '@specials/project-user';

import {AppErrorContent} from '@/ui/common/AppError/AppErrorContent/AppErrorContent';
import {AppErrorGameIsNotAProgress} from '@/ui/common/AppError/AppErrorGameIsNotAProgress/AppErrorGameIsNotAProgress';
import {UIErrorComponent} from '@/ui/common/AppError/components/constants';
import {Image} from '@/ui/kit/Image/Image';

import s from './AppErrorFullScreen.module.css';

export interface FullScreenErrorProps {
  error: HttpError | unknown;
}

export const AppErrorFullScreen: FC<FullScreenErrorProps> = ({error}) => {
  const {image} = useResourcesToken().content.AppErrorFullScreen;
  const errorService = useErrorsServiceToken();

  const isErrorGameIsNotAProgress = errorService.isErrorGameIsNotAProgress(error);

  if (isErrorGameIsNotAProgress) {
    return <AppErrorGameIsNotAProgress error={error} />;
  }

  return (
    <div className={s.root}>
      <Image src={image.src} alt={image.alt} className={s.image} />
      <AppErrorContent error={error} errorComponent={UIErrorComponent.Fullscreen} />
    </div>
  );
};
